import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface TransitProps {
  id: string;
  reason: string;
}

export const useInvalidateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, reason }: TransitProps) => {
      return request({
        path: `transits/invalidate`,
        method: 'POST',
        authenticate: true,
        dataObject: { transitId: id, reason },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.id] });
      toast.success(`Invalidation request was sent!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the invalidation request!`);
    },
  });
};
